import { fetchSsrHtml, fetchSsrStyles, waitForElement } from "../../core/common/ssr-utils.js";
import { getPosExtId } from "./utils.js";
import { getSsrBaseUrl } from "./coursesu-env.js";

const MEALS_PLANNER_PLACEHOLDER = "webc-miam-meals-planner";
const PLANNER_HTML_ENDPOINT = "/v3/planner";
const PLANNER_STYLES_ENDPOINT = "/v3/styles/planner";

export async function injectPlanner(headers) {
  const target = await waitForElement(MEALS_PLANNER_PLACEHOLDER, {
    maxAttempts: 20,
    intervalMs: 250,
  });
  if (!target) {
    console.warn(`[Mealz] ${MEALS_PLANNER_PLACEHOLDER} not found`);
    return;
  }

  try {
    fetchSsrStyles(PLANNER_STYLES_ENDPOINT, getSsrBaseUrl());
    const html = await fetchSsrHtml(PLANNER_HTML_ENDPOINT, headers, { store_id: getPosExtId() }, getSsrBaseUrl());
    target.insertAdjacentHTML("afterend", html);
    target.remove();
  } catch (err) {
    console.error("[Mealz] planner SSR injection failed", err);
  }
}
